import { render, staticRenderFns } from "./Teamless.vue?vue&type=template&id=60ec2a31"
import script from "./Teamless.vue?vue&type=script&lang=js"
export * from "./Teamless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports